export enum AttachmentType {
    Pdf = 1,
    QRCode = 2,
    Both = 3,
}
